import promoService from "../services/promo.service";
import promoMock from "../services/promo.mock";

// REACT_APP_PROMO_DEMO=true uses a browser-local demo store instead of the API.
export const promoDemoMode = () => process.env.REACT_APP_PROMO_DEMO === "true";

const unwrap = (response) => response?.data?.data ?? response?.data?.body ?? response?.data;

export const listPromoCodes = async (params) => {
  if (promoDemoMode()) return promoMock.list(params);
  const res = await promoService.list(params);
  return unwrap(res) || { docs: [], pagination: {} };
};

export const getPromoCode = async (id) => {
  if (promoDemoMode()) return promoMock.get(id);
  return unwrap(await promoService.get(id));
};

export const createPromoCode = async (data) => {
  if (promoDemoMode()) return promoMock.create(data);
  return unwrap(await promoService.create(data));
};

export const listPromoPlans = async () => {
  if (promoDemoMode()) return promoMock.plans();
  return unwrap(await promoService.plans()) || [];
};

export const updatePromoCode = async (id, data) => {
  if (promoDemoMode()) return promoMock.update(id, data);
  return unwrap(await promoService.update(id, data));
};

/** A readable message from an API error (validation lists included). */
export const promoErrorMessage = (error) => {
  const data = error?.response?.data;
  const errors = data?.error?.errors || data?.errors;
  const firstValidation = Array.isArray(errors) ? errors[0]?.msg : null;
  return firstValidation || data?.message || error?.message || "Something went wrong";
};
